<!--
 * @Description: 同时支持H265和H264协议的WS-FLV和HTTP-FLV流视频播放组件
 * @version: 0.0.1
 * @Author: King
 * @Date: 2025-06-06 13:19:11
 * @LastEditors: xinShiCheng
 * @LastEditTime: 2025-06-06 13:19:11
-->
<template>
  <div class="video-player-ws-flv-king-container">
    <!-- 屏幕 -->
    <video ref="myPlayerDom" class="ws-flv-style" :controls="videoConfig.controls" :muted="videoConfig.muted" :autoplay="videoConfig.autoplay"></video>
  </div>
</template>

<script>
import FlvPlayer from "flv.js";
export default {
  name: "FlvVideoPlayer",
  data() {
    return {
      errorCount: 0, // 错误计数
      MAX_ERROR_COUNT: 3, // 最大允许错误次数
      myPlayerObj: null, // 视频实例
      errorFlag: false, // 错误flag
      // 默认video标签配置
      defaultVideoConfig: {
        muted: true,
        autoplay: true,
        controls: false,
      },
      // 默认flv.js配置一
      defaultConfig: {
        hasAudio: false,
        hasVideo: true,
        isLive: true,
      },
      // 默认flv.js配置二（基本不改动的部分）
      defaultConfigBasic: {
        enableWorker: false, // 关闭transmuxing启动分离线程（目前不稳定，默认false）
        enableStashBuffer: false, // 闭IO隐藏缓冲区（默认true）
        autoCleanupSourceBuffer: true, //对SourceBuffer进行自动清除缓存（默认false）
        enableKeyboard: false, // 是否启用键盘快捷键功能，在页面上通过键盘进行操作（默认true）
        enableTouch: false, // 是否启用 Touch 事件功能，在触屏设备上通过手势进行操作（默认true）
        enableMouse: false, // 是否启用鼠标事件功能，在页面上通过鼠标进行操作（默认true）
      },
    };
  },
  props: {
    idIndex: {
      type: Number,
      default: 999,
    },
    // 视频流类型
    streamType: {
      type: String,
      default: "flv",
    },
    // 视频地址
    videoUrl: {
      type: String,
      required: true,
    },
    // 自定义video标签配置，可覆盖默认配置
    videoConfigFa: {
      type: Object,
      default: () => {},
    },
    // 自定义flv.js配置一，可覆盖默认配置
    configFa: {
      type: Object,
      default: () => {},
    },
    // 自定义flv.js配置二（基本不改动的部分），可覆盖默认配置
    /**
     * 直播特有配置：
     * lazyLoad: false, // 如果有足够的数据进行播放，则中断http连接（默认true）
     * stashInitialSize: 384, //初始缓冲区大小（KB），直播建议 1024（默认是384）
     * lowLatencyMode: true, // 是否启用低延迟模式，仅在 isLive 为 true 时生效（默认false）
     **/

    /**
     * 回放特有配置：
     * lazyLoad: true, // 如果有足够的数据进行播放，则中断http连接（默认true）
     * stashInitialSize: 1024, //初始缓冲区大小（KB），直播建议 1024（默认是384）
     **/
    configBasicFa: {
      type: Object,
      default: () => {},
    },
    // 倍速控制（原生video标签）
    playbackRate: {
      type: Number,
      default: 1, // 默认1倍速
      // 倍速数值在此验证范围内才生效
      // validator: val => [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 4, 6, 8, 16].includes(val),
      validator: val => Number.isInteger(val) && val >= 0 && val <= 16,
    },
  },
  computed: {
    videoConfig() {
      return Object.assign({}, this.defaultVideoConfig, this.videoConfigFa);
    },
  },
  watch: {
    videoUrl: {
      async handler() {
        if (this.myPlayerObj) {
          this.isLoading = true;
          try {
            this.myPlayerObj.pause();
            this.myPlayerObj.unload();
            this.myPlayerObj.detachMediaElement();
            this.myPlayerObj.destroy();
          } catch (e) {
            console.error("销毁播放器时出错", e);
          }
          this.myPlayerObj = null;
        }
        await this.init();
        this.isLoading = false;
      },
    },
    // 播放速度（只有非直播时，配置才生效）
    playbackRate: {
      immediate: true,
      handler(newRate) {
        this.$nextTick(() => {
          const video = this.$refs.myPlayerDom;
          if (video && video.readyState >= 1) {
            // 有元数据才能设置
            video.playbackRate = newRate;
            console.log("播放速度已设置为", newRate + "x");
          } else {
            console.warn("video未准备好，无法设置播放速度");
          }
        });
      },
    },
  },
  mounted() {
    // 初始化视频，TMD，VUE2生命周期遇到媒体有关的复杂功能会有问题，双重保险手动加一个nextTick。
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    // 初始化视频
    async init() {
      if (FlvPlayer.isSupported()) {
        console.log("flv.js 支持");
        const videoElement = this.$refs.myPlayerDom;
        const config = Object.assign(this.defaultConfig, this.configFa);
        const configBasic = Object.assign(this.defaultConfigBasic, this.configBasicFa);
        this.myPlayerObj = FlvPlayer.createPlayer(
          {
            type: this.streamType, // 可选flv, mp4
            url: this.videoUrl,
            ...config,
          },
          {
            ...configBasic,
          }
        );
        this.myPlayerObj.attachMediaElement(videoElement); // 绑定视频元素
        this.myPlayerObj.load();
        try {
          await this.myPlayerObj.play();
        } catch (error) {
          console.error("播放视频时出错", error);
        }
        // 初始化后同步一次倍速（防丢失）
        this.$nextTick(() => {
          if (videoElement) {
            videoElement.playbackRate = this.playbackRate;
          }
        });
        // 监听播放器成功播放的最佳兼容写法（官网太垃圾没有文档，民间太杂基本都是无用的）
        this.checkVideoPlaySuccess(videoElement);
        // 错误处理抛出初始之后的播放器对象
        // flv.js 报错监听
        this.myPlayerObj.on("error", error => {
          console.error("flv.js 报错", error);
          this.errorCount++;
          this.errorFlag = true;
          // 若超过最大错误次数，主动销毁播放器
          if (this.errorCount >= this.MAX_ERROR_COUNT) {
            this.destroyPlayer();
            console.warn("播放器连续报错，已主动销毁防止性能问题");
          }
          // 抛出播放器对象
          this.$emit("player-created", {
            index: this.idIndex,
            player: this.myPlayerObj,
            err: true,
          });
        });
        // video 标签出错兜底监听
        videoElement.addEventListener("error", e => {
          console.warn("video标签出错", e);
          this.errorCount++;
          this.errorFlag = true;
          // 若超过最大错误次数，主动销毁播放器
          if (this.errorCount >= this.MAX_ERROR_COUNT) {
            this.destroyPlayer();
            console.warn("播放器连续出错，已主动销毁");
          }
          // 抛出播放器对象
          this.$emit("player-created", {
            index: this.idIndex,
            player: this.myPlayerObj,
            err: true,
          });
        });
        videoElement.addEventListener("stalled", () => {
          console.warn("[VIDEO] 播放卡住了（stalled）");
        });
        videoElement.addEventListener("waiting", () => {
          console.warn("[VIDEO] 等待数据中（waiting）");
        });
      } else {
        // 如果不支持 flv.js，也抛出事件
        this.errorFlag = true;
        console.log("flv.js 不支持");
        this.$emit("player-created", {
          index: this.idIndex,
          player: null,
          err: this.errorFlag,
        });
      }
    },
    // 检查
    checkVideoPlaySuccess(videoElement) {
      let checkCount = 0;
      const maxCheck = 20; // 最多检查20次，防止死循环
      const interval = 500; // 每次检查的间隔
      const check = () => {
        if (!videoElement) return;
        // readyState >= 3 表示已经有足够数据进行播放
        if (videoElement.readyState >= 3 && !this.errorFlag) {
          this.$emit("player-created", {
            index: this.idIndex,
            player: this.myPlayerObj,
            err: false,
          });
        } else {
          checkCount++;
          if (checkCount < maxCheck) {
            setTimeout(() => {
              requestAnimationFrame(check);
            }, interval);
          } else {
            console.warn("播放成功检测超时，地址或网络问题");
          }
        }
      };
      check();
    },
    destroyPlayer() {
      if (this.myPlayerObj) {
        try {
          this.myPlayerObj.pause();
          this.myPlayerObj.unload();
          this.myPlayerObj.detachMediaElement();
          // 关键：延迟 destroy 让 flv.js 有时间停掉内部定时任务
          setTimeout(() => {
            try {
              this.myPlayerObj.destroy();
            } catch (e) {
              console.warn("flv.js destroy 出现异常", e);
            }
            this.myPlayerObj = null;
          }, 100); // 延迟 100ms，避免 destroy 时内部任务仍在访问已销资源
        } catch (e) {
          console.error("销毁播放器失败", e);
        }
      }
    },
  },
  // 销毁组件时销毁视频
  beforeDestroy() {
    this.destroyPlayer();
  },
};
</script>

<style scoped>
.video-player-ws-flv-king-container {
  min-height: 169px;
  min-width: 300px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: #000000;
  position: relative;
}
.ws-flv-style {
  width: 100% !important;
  height: 100% !important;
}
</style>
